import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import {CueCardStack} from '../../../glossary/layout/cue-card-stack';
import {useGetCueCardsForLocation} from '../../../glossary/layout/helpers';

import {RolesPermissionsSidebarSection} from './roles-permissions-sidebar-section';
import {TeamsSidebarSection} from './teams-sidebar-section';
import type {Props as TeamsSectionProps} from './teams-sidebar-section';
import {UsersSidebarSection} from './users-sidebar-section';
import type {Props as UsersSectionProps} from './users-sidebar-section';

export type Props = {
    usersSection: UsersSectionProps;
    teamsSection: TeamsSectionProps;
    status: string | null | undefined;
};

export function UserSetupSidebar(props: Props) {
    const {usersSection, teamsSection} = props;

    const cards = useGetCueCardsForLocation('/setup/user', 'settings-sidebar') || [];
    const isStatusPending = props.status === '2';

    const cueCards = isStatusPending
        ? cards.filter((card) => card.settingsKey !== 'removing_users')
        : cards.filter((card) => card.settingsKey !== 'pending_users');

    return (
        <div className='mb-16'>
            <StackLegacy spacing={16}>
                <UsersSidebarSection {...usersSection} />
                <RolesPermissionsSidebarSection />
                <TeamsSidebarSection {...teamsSection} />
                <CueCardStack cards={cueCards} />
            </StackLegacy>
        </div>
    );
}
